module.exports = __webpack_public_path__ + "img/c14.a156c1f7.png";